module.exports = "https://static.im-cdn.com/mjc/storefront/Compass/static/media/TwitterFoot.587f0570.svg";